import React, { Component } from "react";
import backgroundJob from "../../assets/img/background1.png"
import sadFace from "../../assets/img/sadFace.png"
import './ProfileTemplate.css'
import axios from 'axios';
import loading from 'assets/img/loading.gif'
import config from 'config'
import SocialMediaBadges from './SocialMediaBadges'
import Hidden from "@material-ui/core/Hidden";
import MenuIcon from '@material-ui/icons/Menu';
import ImageDisplay from '../../components/ImageDisplay/ImageDisplay'
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";

import Cotizador1 from "assets/img/Cotizador1.png"
import Cotizador2 from "assets/img/Cotizador2.png"
import Cotizador3 from "assets/img/Cotizador3.png"
import Cotizador4 from "assets/img/Cotizador4.png"

import SeguroTuristaBlanco from "assets/img/SeguroTuristaBlanco.png"
import SeguroTuristaNegro from "assets/img/SeguroTuristaNegro.png"
import SeguroNFRBlanco from "assets/img/SeguroNFRBlanco.png"
import SeguroNFRNegro from "assets/img/SeguroNFRNegro.png"


import Whatsapp from "assets/img/whatsapp.png"
import Llamar from "assets/img/llamar.png"
import Email from "assets/img/email.png"
import Ubicacion from "assets/img/ubicacion.png"
import Guardar from "assets/img/guardar.png"

var qs = require('qs');
var vCardsJS = require('vcards-js');


// ?company=Qualitas&id=1&created=2
export default class Create extends Component {
  
  
    constructor(props){
        super(props)

        
  
        this.state = {
            IDToken: '',
            body: {
                company: "",
                created_at: "",
                agent_id: "",
                agent_name: "El Usuario no Existe",
                agent_link: "",
                agent_link_2: "",
                agent_position: "",
                email: "",
                content: "",
                qrcode: `${config.app.url}/static/media/users/qrcodes/AXA_Marc+Albrand_27.jpeg`,
                address: "",
                number: "",
                image: `${config.app.static_url}/static/media/users/Elon.jpg`,
                active: false,
                backgroundImage: backgroundJob,
                styleb1: "",
                styleb2: "",
                styleb3: "",
                styleb4: "",
                styleb5: "",
                google_maps: "",
                facebook: "",
                instagram: "",
                twitter: "",
                linkedin: "",
                tiktok: "",
                mercadolibre: "",
                amazon: "",
                shopify: "",
                ebay: "",
                otro: "",
                view_count: "",
                styleb1Opt1: `/static/media/llamame.9444529d.png`, //Black style 1
                styleb1Opt2: `/static/media/llamar1.cfc7fdef.png`, //White style 2
                styleb1Opt3: `data:image/png;base64,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`, //Black style 3
                styleb1Opt4: `data:image/png;base64,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`, //White style 4
                fontColor: "white",
                style: "style2",
                cotizarButton: SeguroTuristaNegro,
                cotizarButton2: SeguroNFRNegro
              },
            pathParams: {
                btn1: 'true',
                btn2: 'true',
                btn3: 'true',
                btn4: 'true',
                btn5: 'true'
            },
            error404: true,
            error403: false,
            displayImage: false
        }
    }
    //​styleb1: "https://carnetempresarial.com/static/media/llamame.9444529d.png"


    // Sets Params
    async componentDidMount() {
        if(!this.props.rest.validationProps.isViewingUser){
            this.props.rest.validationProps.setIsViewingUser(true);
        }
        let pathParams = this.setPathParams()
        try{
            if(this.props.rest.auth.currentUserTemplate.agent_id !== pathParams.id){
                this.submitHandlerRead(pathParams);
            } else {
                this.handleLoadPreloadedValues();
            }
        } catch(error){
            console.log(error);
            this.submitHandlerRead(pathParams);
        }
      }

    setPathParams = () => {
        let locationSearch = this.props.rest.location.search;
        var searchParams = locationSearch.substring(1, locationSearch.length)
        var pathParams = searchParams
        pathParams = qs.parse(pathParams);
        if(!pathParams["btn1"]){
            pathParams.btn1 = 'true'
        }
        if(!pathParams["btn2"]){
            pathParams.btn2 = 'true'
        }
        if(!pathParams["btn3"]){
            pathParams.btn3 = 'true'
        }
        if(!pathParams["btn4"]){
            pathParams.btn4 = 'true'
        }
        if(!pathParams["btn5"]){
            pathParams.btn5 = 'true'
        }
        this.setState({pathParams: pathParams})
        return pathParams
    }

    handleLoadPreloadedValues = () => {
        let user = this.props.rest.auth.currentUserTemplate;
        let body = this.state.body
        let templateStyle = JSON.parse(user.backgroundImage)
        let social_links = JSON.parse(user.social_links)
        let content = JSON.parse(user.content)
        let full_url = content.qrcode.split('qrcodes/')[0]
        let qrcode = content.qrcode.split('qrcodes/')[1]
        let image = content.image.split('users/')[1]

        body.company = user.company
        body.display_company = user.display_company
        body.created_at = user.created_at
        body.agent_id = user.agent_id
        body.agent_name = user.agent_name
        body.agent_link = user.agent_link
        body.agent_position = user.agent_position
        body.email = user.email
        body.content = user.content
        body.qrcode = `${full_url}qrcodes/${encodeURIComponent(qrcode)}`
        body.address = content.address
        body.number = content.number.replace(" ", "")
        body.image = `${full_url}${encodeURIComponent(image)}`
        body.backgroundImage = encodeURI(templateStyle.backgroundImage)
        body.styleb1 = templateStyle.styleb1
        body.styleb2 = templateStyle.styleb2
        body.styleb3 = templateStyle.styleb3
        body.styleb4 = templateStyle.styleb4
        body.styleb5 = templateStyle.styleb5
        body.google_maps = social_links.google_maps
        body.facebook = social_links.facebook
        body.instagram = social_links.instagram
        body.twitter = social_links.twitter
        body.linkedin = social_links.linkedin
        body.tiktok = social_links.tiktok
        body.mercadolibre = social_links.mercadolibre
        body.amazon = social_links.amazon
        body.shopify = social_links.shopify
        body.ebay = social_links.ebay
        body.otro = social_links.otro
        body.agent_linK_2 = social_links.agent_link_2
        body.view_count = user.view_count
        body.fontColor = templateStyle.fontColor? templateStyle.fontColor: "black"
        body.style = user.style
        this.setState({error404: false});
    }

    submitHandlerRead = (pathParams) =>{
        this.setState({status: "Leyendo Tarjetas"});
        // Sets loading gif while Reading cards
        this.setState({isReading: true});

        let params = {
            company: pathParams.c,
            agent_id: pathParams.id,
            is_admin: this.props.rest.auth.isAuthenticated.toString()
        }

        axios.get(config.api.invokeUrl + '/read', { params: params })
        .then(response => {
            let templateStyle = JSON.parse(response.data.note.backgroundImage)
            let social_links = JSON.parse(response.data.note.social_links)
            let statusCode = 404
            let fontColor = "black"
            if(response.data.note){
                let body = this.state.body
                let pathParams = this.state.pathParams
                let content = JSON.parse(response.data.note.content)
                let full_url = content.qrcode.split('qrcodes/')[0]
                let qrcode = content.qrcode.split('qrcodes/')[1]
                let image = content.image.split('users/')[1]
                body.company = response.data.note.company
                body.display_company = response.data.note.display_company
                body.created_at = response.data.note.created_at
                body.agent_id = response.data.note.agent_id
                body.agent_name = response.data.note.agent_name
                body.agent_link = response.data.note.agent_link? response.data.note.agent_link : ""
                body.agent_position = response.data.note.agent_position
                body.email = response.data.note.email
                body.content = response.data.note.content
                body.qrcode = `${full_url}qrcodes/${encodeURIComponent(qrcode)}`
                body.address = content.address
                body.number = content.number.split(" ").length >1? content.number.replace(" ", "") : `52${content.number}`
                body.image = `${full_url}${encodeURIComponent(image)}`
                body.backgroundImage = encodeURI(templateStyle.backgroundImage)
                body.styleb1 = templateStyle.styleb1
                body.styleb2 = templateStyle.styleb2
                body.styleb3 = templateStyle.styleb3
                body.styleb4 = templateStyle.styleb4
                body.styleb5 = templateStyle.styleb5
                body.google_maps = social_links.google_maps
                body.facebook = social_links.facebook
                body.instagram = social_links.instagram
                body.twitter = social_links.twitter
                body.linkedin = social_links.linkedin
                body.tiktok = social_links.tiktok
                body.agent_link_2 = social_links.agent_link_2
                body.mercadolibre = social_links.mercadolibre
                body.amazon = social_links.amazon
                body.shopify = social_links.shopify
                body.ebay = social_links.ebay
                body.otro = social_links.otro
                body.view_count = response.data.note.view_count

                if (this.shouldDisplayGoogleMapsButton(body.google_maps)) {
                    pathParams.btn5 = false;
                }

                fontColor = templateStyle.fontColor? templateStyle.fontColor: "black"
                body.fontColor = fontColor

                this.setState({body: body, pathParams: pathParams});
                if(response.data.note.statusCode) statusCode = response.data.note.statusCode;
                else {
                    statusCode = response.data.statusCode;
                }
            }

          if (statusCode === 200){
            this.setState({error404: false, error403: false})
            this.props.rest.auth.setProductsAndServices(true);
            //We add current URL to saved user
            let UserTemplate = response.data.note;
            UserTemplate.userURL = window.location.href;
            // let fontColor = this.chooseFontColor(templateStyle.styleb1);
            let style = this.chooseSocialMediaStyles(templateStyle.styleb1);
            UserTemplate.fontColor = fontColor;
            UserTemplate.style = style;
            this.props.rest.auth.setCurrentUserTemplate(UserTemplate);
            
            this.forceUpdate();
          } else if (statusCode === 404){
            this.setState({error404: true, error403: false})
            this.props.rest.validationProps.setIsViewingUser(false);
          } else if (statusCode === 403){
            this.setState({error403: true, error404: false})
            this.props.rest.validationProps.setIsViewingUser(false);
          }
          this.setState({isReading: false});
        })
        .catch(error =>{
          console.log(error);
          this.setState({isReading: false});
        })
        
    };

    shouldDisplayGoogleMapsButton = (mapsLocationValue) => {
        if (mapsLocationValue == "") return true
        return false
    }


    handleQRClick=() =>{
        //create a new vCard
        var vCard = vCardsJS();
        
        //set properties
        vCard.firstName = 'Eric';
        vCard.middleName = 'J';
        vCard.lastName = 'Nesser';
        vCard.organization = 'ACME Corporation';
        vCard.photo.attachFromUrl('https://avatars2.githubusercontent.com/u/5659221?v=3&s=460', 'JPEG');
        vCard.workPhone = '312-555-1212';
        vCard.birthday = new Date(1985, 0, 1);
        vCard.title = 'Software Developer';
        vCard.url = 'https://github.com/enesser';
        vCard.note = 'Notes on Eric';

        let vcardText = 'BEGIN:VCARD\n' +
        'VERSION:3.0\n' +
        `N:${this.state.body.agent_name}\n` +
        `FN:${this.state.body.agent_name}\n` +
        `ORG:${this.state.body.company}\n` +
        `TEL;TYPE=CELL:${this.state.body.number}\n` +
        `EMAIL;TYPE=WORK:${this.state.body.email}\n` +
        `EMAIL;TYPE=X-Website:${this.state.body.email}\n` +
        'END:VCARD'
        
        vcardText = encodeURIComponent(vcardText);
        // var blob = new Blob([vcardText], {type: "text/text+application+vcard"});
        window.open("data:text/vcard;charset=UTF-8," + vcardText, '_blank');
    }

    retVCard = () => {
        let vcardText = 'BEGIN:VCARD\n' +
        'VERSION:3.0\n' +
        `N;CHARSET=iso-8859-1:;${this.state.body.agent_name};;\n` +
        `FN;CHARSET=iso-8859-1:${this.state.body.agent_name}\n` +
        `ORG;CHARSET=iso-8859-1:${this.state.body.company}\n` +
        `TITLE;CHARSET=iso-8859-1:${this.state.body.agent_position}\n` +
        `TEL;TYPE=CELL:${this.state.body.number}\n` +
        `ADR;CHARSET=iso-8859-1;TYPE=WORK:${this.state.body.address}\n` +
        `EMAIL;TYPE=WORK:${this.state.body.email}\n` +
        // `EMAIL;TYPE=X-Website:${this.state.body.email}\n` +
        `URL:${window.location.href}\n` +
        'END:VCARD'

        // let card = encodeURIComponent(vcardText);
        let card = btoa(vcardText);
        return `data:text/vcard;base64,${card}`
    }

    retVCard_original = () => {
        let vcardText = 'BEGIN:VCARD\n' +
        'VERSION:4.0\n' +
        `N;CHARSET=iso-8859-1:;${this.state.body.agent_name};;\n` +
        `FN;CHARSET=iso-8859-1:${this.state.body.agent_name}\n` +
        `ORG;CHARSET=iso-8859-1:${this.state.body.company}\n` +
        `TITLE;CHARSET=iso-8859-1:${this.state.body.agent_position}\n` +
        `TEL;TYPE=CELL:${this.state.body.number}\n` +
        `ADR;TYPE=WORK:${this.state.body.address}\n` +
        `EMAIL;TYPE=WORK:${this.state.body.email}\n` +
        `EMAIL;TYPE=X-Website:${this.state.body.email}\n` +
        `URL:${window.location.href}\n` +
        'END:VCARD'

        // let card = encodeURIComponent(vcardText);
        let card = btoa(vcardText);
        return `data:text/vcard;base64,${card}`
    }

    retVCardFileName = () => this.state.body.agent_name + ".vcf"

    retVCard2 = () => {
        let vcardText = 'BEGIN:VCARD\n' +
        'VERSION:4.0\n' +
        `N:${this.state.body.agent_name}\n` +
        `FN:${this.state.body.agent_name}\n` +
        `ORG:${this.state.body.company}\n` +
        `TITLE:${this.state.body.agent_position}\n` +
        `TEL;TYPE=CELL:${this.state.body.number}\n` +
        `EMAIL;TYPE=WORK:${this.state.body.email}\n` +
        `EMAIL;TYPE=X-Website:${this.state.body.email}\n` +
        'END:VCARD'

        let card = encodeURIComponent(vcardText);
        // let card = btoa(vcardText);
        return `data:text/vcard,${card}`
    }

    handleDownload = () => {
        let vcardText = 'BEGIN:VCARD\n' +
        'VERSION:4.0\n' +
        `N:${this.state.body.agent_name}\n` +
        `FN:${this.state.body.agent_name}\n` +
        `ORG:${this.state.body.company}\n` +
        `TITLE:${this.state.body.agent_position}\n` +
        `TEL;TYPE=CELL:${this.state.body.number}\n` +
        `EMAIL;TYPE=WORK:${this.state.body.email}\n` +
        `EMAIL;TYPE=X-Website:${this.state.body.email}\n` +
        'END:VCARD'

        let card = encodeURIComponent(vcardText);

        function saveAs(uri, filename) {
            var link = document.createElement('a');
            if (typeof link.download === 'string') {
              link.href = uri;
              link.download = filename;
          
              //Firefox requires the link to be in the body
              document.body.appendChild(link);
              
              //simulate click
              link.click();
          
              //remove the link when done
              document.body.removeChild(link);
            } else {
              window.open(uri);
            }
          }
          
          var file = `data:text/vcard,${card}`
          saveAs(file, 'logo.vcf');
    }

    retTel = () => {
        return `tel:${this.state.body.number}`
    }

    retWhats = () => {
        if(this.state.pathParams?.b){
            return `https://wa.me/${this.state.body.number}?text=${encodeURIComponent(`Saludos desde la compañía ${this.state.pathParams.b} ¿Podrías brindarme informes?`)}`
        }
        return `https://wa.me/${this.state.body.number}?text=${encodeURIComponent(`Saludos! ¿Podrías brindarme informes?`)}`
    }

    retEmail = () => {
        if(this.state.pathParams?.b){
            return `mailto:${this.state.body.email}?Subject=${encodeURIComponent(`Saludos desde la compañía ${this.state.pathParams.b} ¿Podrías brindarme informes?`)}`
        }
        return `mailto:${this.state.body.email}?Subject=${encodeURIComponent(`Saludos! ¿Podrías brindarme informes?`)}`
    }

    retGoogleMaps = () => {
        let sublink = this.state.body.google_maps.substring(0,4)
        if (sublink === "") return
        if (sublink !== "http")
            window.open(`https://${this.state.body.google_maps}`, '_blank');
        else
            window.open(this.state.body.google_maps, '_blank');
        return `${this.state.body.google_maps}`
    }

    retNFR = () => {
        let sublink = this.state.body.google_maps.substring(0,4)
        if (sublink === "") return
        if (sublink !== "http")
            window.open(`https://${this.state.body.agent_link_2}`, '_blank');
        else
            window.open(this.state.body.agent_link_2, '_blank');
        return `${this.state.body.agent_link_2}`
    }

    chooseFontColor = (b1style) => {
        b1style = b1style.replace(config.app.url, "")
        b1style = b1style.replace(config.app.url2, "")
        let body = this.state.body
        if(b1style === this.state.body.styleb1Opt2 || b1style === this.state.body.styleb1Opt4){
            body.fontColor = "white"
            
        } else {
            body.fontColor = "black"
        }
        this.setState({body: body});
        return body.fontColor
    }

    chooseSocialMediaStyles = (b1style) => {
        b1style = b1style.replace(config.app.url, "")
        b1style = b1style.replace(config.app.url2, "")
        let body = this.state.body
        if(b1style === this.state.body.styleb1Opt1){
            body.style = "style1"
            body.cotizarButton = SeguroTuristaNegro
            body.cotizarButton2 = SeguroNFRNegro
        } else if(b1style === this.state.body.styleb1Opt2){
            body.style = "style2"
            body.cotizarButton = SeguroTuristaBlanco
            body.cotizarButton2 = SeguroNFRBlanco
        } else if(b1style === this.state.body.styleb1Opt3){
            body.style = "style3"
            body.cotizarButton = SeguroTuristaNegro
            body.cotizarButton2 = SeguroNFRNegro
        } else {
            body.style = "style4"
            body.cotizarButton = SeguroTuristaBlanco
            body.cotizarButton2 = SeguroNFRBlanco
        }
        this.setState({body: body});
        return body.style
    }

    capitalizeString = (str) =>{
        let arrayStrings = str.split(" ");
        let newArrayStrings = []

        arrayStrings.map((word) => {
            let capitalizedWord = ""
            // Unwanted capitalized words
            if((word.toUpperCase() === 'DE' || word.toUpperCase() === 'DEL' || word.toUpperCase() === 'LA' || word.toUpperCase() === 'LAS' || 
            word.toUpperCase() === 'A' || word.toUpperCase() === 'E' || word.toUpperCase() === 'Y' || word.toUpperCase() === 'O' || word.toUpperCase() === 'U' || 
            word.toUpperCase() === 'PARA' || word.toUpperCase() === 'EL') && arrayStrings[0] !== word){
                capitalizedWord = word.toLowerCase();
            } // Wanted capitalized words
            else if(word.toUpperCase() === "AM" || word.toUpperCase() === "KS"){
                capitalizedWord = word.toUpperCase()
            } 
            else {
                capitalizedWord = word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            }
            return newArrayStrings.push(capitalizedWord);
        })

        let newString = newArrayStrings.join(" ")
        return newString
    }

    handleDisplayImage = (newSelectedImage=null) => {
        var selectedImage = this.state.selectedImage
        if(newSelectedImage){
            selectedImage = newSelectedImage;
        }
        let displayImage = this.state.displayImage;
        displayImage = !displayImage;
        this.setState({displayImage, selectedImage});
    }

    handleSelectImage = () => {
        
    }


    render(){
        console.log(this.state)
        //Renders Loading gif while making requests
        if(this.state.isReading){
            return (
                <center>
                    <Hidden mdUp>
                    <img style={{marginRight:"79px"}} src={loading} alt="loading..." width="80%"  height="80%"/>
                    <h2 style={{marginRight:"79px"}}>{this.state.status}</h2>
                    </Hidden>
                    <Hidden mdDown>
                    <img style={{marginRight:"79px"}} src={loading} alt="loading..."/>
                    <h1 style={{marginRight:"79px"}}>{this.state.status}</h1>
                    </Hidden>
                </center>
            )
        }

        //Renders Loading gif while making requests
        if(this.state.error404){
            return (
              <center>
                  <Hidden mdUp implementation="css">
                        <MenuIcon
                            id="menuIconNormal"
                            onClick={this.props.handleDrawerToggle}
                        >
                        </MenuIcon>
                    </Hidden>
                <img style={{marginRight:"79px"}} src={sadFace} alt="Not found" width="128px" height="128px"/>
                <h1 style={{marginRight:"79px"}}>Usuario no encontrado</h1>
                <h5 style={{marginRight:"79px"}}>Si usted es el dueño de esta tarjeta, por favor contacte a su administrador</h5>
              </center>
            )
        }

        //Renders Loading gif while making requests
        if(this.state.error403){
            return (
              <center>
                  <Hidden mdUp implementation="css">
                                <MenuIcon
                                    id="menuIconNormal"
                                    onClick={this.props.handleDrawerToggle}
                                >
                                </MenuIcon>
                            </Hidden>
                <img style={{marginRight:"79px"}} src={sadFace} alt="Not found" width="128px" height="128px"/>
                <h1 style={{marginRight:"79px"}}>Tarjeta Inactiva</h1>
                <h5 style={{marginRight:"79px"}}>Si usted es el dueño de esta tarjeta, por favor contacte a su administrador</h5>
              </center>
            )
        }

        if(this.state.displayImage){
            return (
                <>
                    <ImageDisplay handleDisplayImage={this.handleDisplayImage} image={this.state.selectedImage}></ImageDisplay>
                </>
            )
        }

        return(
            <div style={{
                }}>
                <GridContainer  style={{
                    backgroundImage: `url(${this.state.body.backgroundImage})`,
                }}
                id="backgroundContainerImage">
                    
                    {/* Burger Menu */}
                    <GridContainer xs={12} sm={12} md={12} id="adjustGrids">
                        <GridItem xs={10} sm={10} md={10}>
                        </GridItem>
                        <GridItem xs={2} sm={2} md={2} style={{backgroundColor: "black", zIndex: "9999"}}>
                        </GridItem>
                    </GridContainer>
                    

                    <GridItem xs={12} sm={12} md={12} id="adjustGridProfileImage">
                        <center>
                            <img 
                                style={{cursor: "pointer"}} 
                                id="profilePicture"
                                alt="perfil" 
                                src={this.state.body.image} 
                                onClick={() => {this.handleDisplayImage(this.state.body.image)}}
                            />
                            <div id="burgerContainer">
                            <Hidden mdUp implementation="css">
                                <MenuIcon
                                    id={"burgerMenu"}
                                    style={{color: this.state.body.fontColor}}
                                    onClick={this.props.handleDrawerToggle}
                                >
                                </MenuIcon>
                            </Hidden>
                        </div>
                        </center>
                        
                        
                        
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12} id="adjustGrids" style={{textAlign: "center"}}>
                        <center>
                            <div id={"textContainer"}>
                                <h2 id="textName" style={{color: this.state.body.fontColor}}>{this.state.body.agent_name}</h2>
                                <p id="textPosition" style={{color: this.state.body.fontColor}}>{this.state.body.agent_position}</p>
                                <p id="textCompany" style={{color: this.state.body.fontColor}}>{this.state.body.display_company}</p>
                            </div>
                        </center>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12} style={{textAlign: "center"}} id="adjustGrids">
                        <div id={"actionButtonsContainer"}>
                            {this.state.pathParams.btn1 === 'true' && <div>
                                <a href={this.retVCard()} download={this.retVCardFileName()} target="_blank" rel="noopener noreferrer">
                                    <img class="actionButtons" src={Guardar} alt="Guardar"></img>
                                </a>
                            </div>}

                            {this.state.pathParams.btn2 === 'true' && <div>
                                    <a href={this.retTel()} target="_blank" rel="noopener noreferrer">
                                        <img class="actionButtons" src={Llamar} alt="Llamar"></img>
                                    </a>
                            </div>}

                            {this.state.pathParams.btn3 === 'true' && <div>
                                    <a href={this.retWhats()} target="_blank" rel="noopener noreferrer">
                                        <img class="actionButtons" src={Whatsapp} alt="Whatsapp"></img>
                                    </a>
                            </div>}

                            {this.state.pathParams.btn4 === 'true' && <div>
                                    <a href={this.retEmail()} target="_blank" rel="noopener noreferrer">
                                        <img class="actionButtons" src={Email} alt="Email"></img>
                                    </a>
                            </div>}

                            {this.state.pathParams.btn5 === 'true' && <div>
                                    <div onClick={this.retGoogleMaps}>
                                        <img class="actionButtons" src={Ubicacion} alt="Ubicación"></img>
                                    </div>
                            </div>}
                        </div>
                        
                    </GridItem>

                    {/* </GridContainer> */}
                    <GridItem xs={12} sm={12} md={12} style={{textAlign: "center"}} id="adjustGrids">
                        <SocialMediaBadges 
                            facebook={this.state.body.facebook}
                            instagram={this.state.body.instagram}
                            twitter={this.state.body.twitter}
                            linkedin={this.state.body.linkedin}
                            tiktok={this.state.body.tiktok}
                            // amazon={this.state.body.amazon}
                            // mercadolibre={this.state.body.mercadolibre}
                            // ebay={this.state.body.ebay}
                            // shopify={this.state.body.shopify}
                            otro={this.state.body.otro}
                            handleBadgeClick={this.handleBadgeClick}
                            fontColor={this.state.body.fontColor}
                            buttonStyle={this.state.body.style}/>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12} style={{textAlign: "center"}} id="adjustGrids">
                        {this.state.body.agent_link !== "empty" &&
                            <a href={this.state.body.agent_link} target="_blank" rel="noopener noreferrer">
                                <img src={this.state.body.cotizarButton} id={"quoteButton"} alt="cotizarTurista"></img>
                            </a>
                        }
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12} style={{textAlign: "center"}} id="adjustGrids">
                        {this.state.body.agent_link_2 !== "" &&
                            // <a href={this.state.body.agent_link_2} target="_blank" rel="noopener noreferrer">
                                <img onClick={this.retNFR} src={this.state.body.cotizarButton2} id={"quoteButton"} alt="cotizarNFR"></img>
                            // </a>
                        }
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12} style={{textAlign: "center"}} id="adjustGrids">
                        <div style={{marginTop: "60px"}}>
                            <center>
                                <div id="qrCode">
                                    {/* <a href={this.retVCard()} download={this.retVCardFileName()} target="_blank"> */}
                                        {/* <img style={{cursor: "pointer"}} src={this.state.body.qrcode} id="qrCode" alt="qr" onClick={() => {this.handleDisplayImage(this.state.body.qrcode)}}/>
                                        <p id="profileQR" style={{color: this.state.body.fontColor, marginTop: "0px"}} class="whiteBoldText">¡Escanéame!</p> */}
                                    {/* </a> */}
                                </div>
                                
                            </center>
                        </div>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12} style={{textAlign: "center"}} id="adjustGrids">
                        <div id="visitCounter" style={{color: this.state.body.fontColor}}>
                            {this.state.body.view_count} Personas han visto esta tarjeta
                        </div>
                    </GridItem>  

                        <div id="visitCounter">
                        </div>

                </GridContainer> 
            </div>
        );
    }
}
